<script>
    import Config from "@/services/Config";
    import IConstants from "@/common/constants/IConstants.js";
    import ServiceUtils from "@/common/utils/ServiceUtils.js";
    import {createNamespacedHelpers} from "vuex";

    const {mapState: mapNewsState} = createNamespacedHelpers("news");

    export default {
        name: 'InAppBrowserMixins',
        mixins: [],
        data() {
            return {
                deepLinkCloseFXIOS: Config.getDeepLinkCloseFXIOS(),
                deepLinkCloseFXAndroid: Config.getDeepLinkCloseFXAndroid(),
                deepLinkCloseCryptoIOS: Config.getDeepLinkCloseCryptoIOS(),
                deepLinkCloseCryptoAndroid: Config.getDeepLinkCloseCryptoAndroid(),
                deepLinkCloseSTIOS: Config.getDeepLinkCloseSTIOS(),
                deepLinkCloseSTAndroid: Config.getDeepLinkCloseSTAndroid()
            }
        },
        mounted() {
        },
        computed: {
            ...mapNewsState({
                needRegisterPasskey: state => state.needRegisterPasskey,
            }),
        },
        methods: {
            inAppBrowserCloseable() {
                this.$service.getService("news").getAgreeNews().then((res) => {
                    if (!this.isMyPageCompleted(res)) return;
                    this.closing(res)
                });
            },
            store3rdCustomParams() {
                let params = new URLSearchParams(window.location.search);
                if (params.has(IConstants.CUSTOM_PARAM.APP_SOURCE_TYPE)) localStorage.setItem(IConstants.CUSTOM_PARAM.APP_SOURCE_TYPE, params.get(IConstants.CUSTOM_PARAM.APP_SOURCE_TYPE));
                if (params.has(IConstants.CUSTOM_PARAM.X_SOURCE_ID)) localStorage.setItem(IConstants.CUSTOM_PARAM.X_SOURCE_ID, params.get(IConstants.CUSTOM_PARAM.X_SOURCE_ID))
            },
            closing(res) {
                const xSourceId = localStorage.getItem(IConstants.CUSTOM_PARAM.X_SOURCE_ID);
                const appSourceType = localStorage.getItem(IConstants.CUSTOM_PARAM.APP_SOURCE_TYPE);
                if (!ServiceUtils.hasValue(appSourceType)) return;

                let closeLink;
                if (this.isCryptoApp(appSourceType)) {
                    if (this.isCryptoTradingReady(res)) {
                        if (this.isCryptoIosApp(appSourceType)) closeLink = this.deepLinkCloseCryptoIOS;
                        else if (this.isCryptoAndroidApp(appSourceType)) closeLink = this.deepLinkCloseCryptoAndroid
                    } else {
                        this.$router.push({name: "cryptoPageRedirect"});
                        return
                    }
                } else if (this.isFxApp(appSourceType)) {
                    if (this.isFxIosApp(appSourceType)) closeLink = this.deepLinkCloseFXIOS;
                    else if (this.isFxAndroidApp(appSourceType)) closeLink = this.deepLinkCloseFXAndroid
                } else if (this.isStApp(appSourceType)) {
                    if (this.isStIosApp(appSourceType)) closeLink = this.deepLinkCloseSTIOS;
                    else if (this.isStAndroidApp(appSourceType)) closeLink = this.deepLinkCloseSTAndroid
                }

                if (closeLink) {
                    localStorage.removeItem(IConstants.CUSTOM_PARAM.APP_SOURCE_TYPE);
                    localStorage.removeItem(IConstants.CUSTOM_PARAM.X_SOURCE_ID);
                    let customCloseLink = this.buildUrlWithCustomParam(closeLink, IConstants.CUSTOM_PARAM.X_SOURCE_ID, xSourceId);
                    window.location.href = customCloseLink
                }
            },
            isCryptoApp(appSourceType) {
                return appSourceType.includes(IConstants.APP_SOURCE_TYPE.CRYPT_CFD)
            },
            isCryptoIosApp(appSourceType) {
                return appSourceType.includes(IConstants.APP_SOURCE_TYPE.CRYPT_CFD_IOS)
            },
            isCryptoAndroidApp(appSourceType) {
                return appSourceType.includes(IConstants.APP_SOURCE_TYPE.CRYPT_CFD_ANDROID)
            },
            isFxApp(appSourceType) {
                return appSourceType.includes(IConstants.APP_SOURCE_TYPE.NTD_FX)
            },
            isFxIosApp(appSourceType) {
                return appSourceType.includes(IConstants.APP_SOURCE_TYPE.NTD_FX_IOS)
            },
            isFxAndroidApp(appSourceType) {
                return appSourceType.includes(IConstants.APP_SOURCE_TYPE.NTD_FX_ANDROID)
            },
            isStApp(appSourceType) {
                return appSourceType.includes(IConstants.APP_SOURCE_TYPE.COPY_TRADE)
            },
            isStIosApp(appSourceType) {
                return appSourceType.includes(IConstants.APP_SOURCE_TYPE.COPY_TRADE_IOS)
            },
            isStAndroidApp(appSourceType) {
                return appSourceType.includes(IConstants.APP_SOURCE_TYPE.COPY_TRADE_ANDROID)
            },
            isMyPageCompleted(res) {
                let hasReAgreementNews = res.listAmsCustomerNewsView && res.listAmsCustomerNewsView.length > 0;
                let hasAgreementNews = res.listAgreeNewsInfo && res.listAgreeNewsInfo.length > 0;
                let hasForceNews = res.listForceNewsInfo && res.listForceNewsInfo.length > 0;
                return !hasReAgreementNews && !hasAgreementNews && !hasForceNews && !this.needRegisterPasskey
            },
            isCryptoTradingReady(res) {
                const CRYPTO_OPEN_COMPLETED_STATUS = [9, 10];
                const ARRIVAL_CONFIRMED = 6;
                const isCompleted = CRYPTO_OPEN_COMPLETED_STATUS.includes(res.cryptoFxStatus);
                return res.cryptoFxStatus === 8 ? res.postDocCryptoStatus === ARRIVAL_CONFIRMED : isCompleted;
            },
            buildUrlWithCustomParam(originUrl, key, value) {
                if (!ServiceUtils.hasValue(key) || !ServiceUtils.hasValue(value)) return originUrl;

                const [baseUrl, searchString] = originUrl.split('?');
                const params = new URLSearchParams(searchString || '');
                params.set(key, value);

                return `${baseUrl}?${params.toString()}`;
            }
        },
    };
</script>
